import React from 'react';
import { Link } from 'react-router-dom';
import { SpacingAmount } from '../components/Spacing';
import { Header, Spacing, Integrations, Button, Footer } from '../components';
import './ProductPage.css';
import './LandingV3.css';

export default () => {
    return (
        <div>
            <Header />
            <div className="pdSectionContainer">
                <div className="ProductBackground">
                    <div className="pdHeroSplit">
                        <div className="pdHeroSplitSide">
                            <Spacing amount={SpacingAmount.Spacing60} />
                            <div className="pdHeroTagline">
                                DINE-IN ORDERING
                            </div>
                            <div
                                className="pdHeroText"
                                style={{ width: '86%' }}
                            >
                                Future-proof your store
                            </div>
                            <div className="pdHeroDescr">
                                The most customer and waiter centric table and
                                hotel ordering system in the industry. Order,
                                call for the waiter, and securely pay digitally.
                            </div>
                            <Button
                                href="/contact"
                                text="Get started with us"
                                showChevron
                            />
                        </div>
                        <div className="pdHeroSplitSide">
                            <Spacing amount={SpacingAmount.Spacing60} />
                            <img
                                src="/assets/landing/v3/productPages/pd-dine-in.png"
                                className="pdHeroImg"
                            />
                        </div>
                    </div>

                    <Spacing amount={SpacingAmount.Spacing60} />
                    <div className="ProductSplitViewRWM">
                        <div className="ProductSplitViewRight">
                            <img
                                src={
                                    '/assets/landing/v3/productPages/dine-in-management.png'
                                }
                                className="ProductImage"
                            />
                        </div>
                        <div className="ProductSplitViewSide">
                            <div className="v3LandingProductName">
                                Table and room management
                            </div>
                            <div className="v3LandingProductDescription">
                                {' '}
                                Customers can order from their phone so that you
                                can manage their table or room and capture their
                                data respectfully to build more loyal customers.
                            </div>
                            <Link to="/contact">
                                <div className="ProductLink">
                                    Book a Demo
                                    <img
                                        src="/assets/landing/v3/link-chevron.svg"
                                        className="v3LandingProductChevron"
                                    />
                                </div>
                            </Link>
                        </div>
                    </div>
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <div className="ProductSplitView">
                        <div className="ProductSplitViewSide">
                            <div className="v3LandingProductName">
                                A happier customer
                            </div>
                            <div className="v3LandingProductDescription">
                                {' '}
                                Never have a customer trying to wave down staff
                                again. Save over 30 minutes for the customer and
                                your staff per table with built in customizeable
                                requests for water, support, or room service.
                            </div>
                            <Link to="/contact">
                                <div className="ProductLink">
                                    Book a Demo
                                    <img
                                        src="/assets/landing/v3/link-chevron.svg"
                                        className="v3LandingProductChevron"
                                    />
                                </div>
                            </Link>
                        </div>
                        <div className="ProductSplitViewSide ProductSplitViewRight">
                            <img
                                src="/assets/landing/v3/productPages/dine-in-customer.png"
                                className="ProductImage"
                            />
                        </div>
                    </div>
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <Spacing amount={SpacingAmount.Spacing60} />
                    <div className="ProductSplitViewRWM">
                        <div className="ProductSplitViewRight">
                            <img
                                src="/assets/landing/v3/productPages/dine-in-design.png"
                                className="ProductImage"
                                style={{ paddingLeft: '28px' }}
                            />
                        </div>
                        <div className="ProductSplitViewSide">
                            <div className="v3LandingProductName">
                                Best-in-class design
                            </div>
                            <div className="v3LandingProductDescription">
                                {' '}
                                As a design-first partner we provide the most
                                intuitive and seamless platform and onboarding.
                                Directly integrate all order channels with your
                                POS or operate Mentum standalone.
                            </div>
                            <Link to="/contact">
                                <div className="ProductLink">
                                    Book a Demo
                                    <img
                                        src="/assets/landing/v3/link-chevron.svg"
                                        className="v3LandingProductChevron"
                                    />
                                </div>
                            </Link>
                            <a href="/contact">
                                <div className="ProductLink">
                                    Learn more about mobile app{' '}
                                    <img
                                        src="/assets/landing/v3/link-chevron.svg"
                                        className="v3LandingProductChevron"
                                    />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="v3ContentContainer">
                    <Spacing amount={SpacingAmount.Spacing60} />
                    <Spacing amount={SpacingAmount.Spacing60} />
                    <div className="v3CenteredHeader">POS Integrations</div>
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <div className="v3CenteredDescription">
                        Handle higher volumes of orders with more efficient
                        labor management in your operation to push a higher
                        overall quality of service.
                    </div>
                    <Integrations />
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <Spacing amount={SpacingAmount.Spacing60} />
                    <div className="v3CenteredHeader">
                        Check out our other products
                    </div>
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <div className="CheckoutOthersContainer">
                        <div className="CheckoutContent">
                            <Link to="/product/qr" style={{ color: 'inherit' }}>
                                <img
                                    src="/assets/landing/v3/productPages/checkout-qr.png"
                                    className="CheckoutImg"
                                />
                                <div className="CheckoutTag">
                                    QR Dine-in & Pay
                                </div>
                                <div className="CheckoutDescrp">
                                    Future proof your store with the industries
                                    most seamless digital ordering tool for your
                                    QSR, Hotel, Bar, Club, or Food Truck with
                                    take away ordering.
                                </div>
                            </Link>
                        </div>
                        <div className="CheckoutContent">
                            <Link
                                to="/product/delivery"
                                style={{ color: 'inherit' }}
                            >
                                <img
                                    src="/assets/landing/v3/productPages/checkout-d.png"
                                    className="CheckoutImg"
                                />
                                <div className="CheckoutTag">
                                    Delivery Aggregation
                                </div>
                                <div className="CheckoutDescrp">
                                    The most customer and waiter centric table
                                    and hotel ordering system in the industry.
                                    Order, call for the waiter, and securely pay
                                    digitally.{' '}
                                </div>
                            </Link>
                        </div>
                        <div className="CheckoutContent">
                            <Link
                                to="/product/kiosk"
                                style={{ color: 'inherit' }}
                            >
                                <img
                                    src="/assets/landing/v3/productPages/checkout-kiosk.png"
                                    className="CheckoutImg"
                                />
                                <div className="CheckoutTag">
                                    Expressive Kiosk
                                </div>
                                <div className="CheckoutDescrp">
                                    Save on labour costs and customer wait times
                                    by giving patrons control of their own
                                    dining experience.
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

                <Spacing amount={SpacingAmount.Spacing60} />

                <div className="v3ReadyToGetStartedContainer ReadySectionBackground">
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <div className="v3ReadyHeader">Ready to get started?</div>
                    <Spacing amount={SpacingAmount.Spacing38} />

                    <div className="v3CenteredDescription">
                        Get in touch and set up a free demo of how our products
                        can future proof your operations.
                    </div>
                    <Spacing amount={SpacingAmount.Spacing38} />
                    <Link to="/contact">
                        <Button text="Book a Demo" />
                    </Link>
                    <Spacing amount={SpacingAmount.Spacing128} />
                </div>
                <Footer />
            </div>
        </div>
    );
};
